/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import DataTableGrid from '../../../../shared/components/formUtilities/useTable';
import { initializeColumns } from './paymentScheduleColumn';
import { PaymentService } from '../../../../services/paymentService';
import { BorrowerService } from '../../borrowerService';
import { SectionWithHeading } from '../../../../shared/components/common/sectionWithHeading';
import { useTranslation } from 'react-i18next';
import { LocalStorageKey } from '../../../../constants/localStorageKeys';
import { MandateCard } from '../directDebit/mandateCard';

export const BorrowerPaymentSchedule = () => {
	const paymentService = new PaymentService();
	const borrowerService = new BorrowerService();
	const [paymentSchedule, setPaymentSchedule] = useState([]);
	const [loading, setLoading] = useState(false);
	const [activeLoans, setActiveLoans] = useState([]);
	const [activeLoanId, setActiveLoanId] = useState('');
	const { t } = useTranslation();
	const columns = initializeColumns(t);

	useEffect(() => {
		getActiveLoans();
	}, []);

	const getActiveLoans = () => {
		borrowerService
			.getActiveLoans()
			.then((resp) => {
				if (resp.data && resp.data.length > 0) {
					setActiveLoans(resp.data);
					const storedLoanId = sessionStorage.getItem(LocalStorageKey.activeLoanId);
					const initialLoanId = storedLoanId && resp.data.some(loan => loan.loanId === storedLoanId)
						? storedLoanId
						: resp.data[0].loanId;
					setActiveLoanId(initialLoanId);
					fetchPaymentSchedule(initialLoanId);
				}
			})
			.catch((err) => { });
	};

	const handleLoanChange = (event) => {
		const loanId = event.target.value;
		setActiveLoanId(loanId);
		fetchPaymentSchedule(loanId);
	};

	const fetchPaymentSchedule = (loanId) => {
		setLoading(true);
		paymentService
			.getPaymentSchedule(loanId)
			.then((resp) => {
				setPaymentSchedule(resp.data);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	return (
		<>
			{activeLoanId && (
				<Box className="mb-4">
					<MandateCard loanId={activeLoanId} />
				</Box>
			)}
			
			<SectionWithHeading
				heading={t('paymentSchedule')}
				children={
					<>
						{activeLoans.length > 1 && (
							<Box className="mb-4">
								<FormControl fullWidth size="small" className="!mt-2" sx={{ maxWidth: 300 }}>
									<InputLabel id="loan-schedule-select-label">{t('selectLoan')}</InputLabel>
									<Select
										labelId="loan-schedule-select-label"
										label={t('selectLoan')}
										value={activeLoanId}
										onChange={handleLoanChange}
									>
										{activeLoans.map((loan) => (
											<MenuItem key={loan.loanId} value={loan.loanId}>
												{loan.name || `Loan ${loan.applicationId}`}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Box>
						)}
						<DataTableGrid
							hideSerialNumbers
							name={'paymentScheduleTbl'}
							columns={columns}
							records={paymentSchedule}
							showEditColumnsButton={false}
							isPagination={false}
							loading={loading}></DataTableGrid>
					</>
				}></SectionWithHeading>
		</>
	);
};
